<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "department",
  data() {
    return {};
  },
  created() {}
};
</script>
